class LocationOBJ{
    constructor(id, name, aniTimestamp){
        this.id = id;
        this.name = name;
        this.aniTimestamp = aniTimestamp;
    }
}

export default LocationOBJ;